import React from 'react';
import { Box, Container, Grid } from '@mui/material';
import FinancialCategoryList from './financialCategoryList';

export default function FinancialCategoriesTab() {
  return (
    <Box sx={{ p: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FinancialCategoryList
              title="Categoria para Entradas"
              entityLabel="Categoria de Entrada"
              basePath="/financial/income-category-catalog"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FinancialCategoryList
              title="Categoria para Saídas"
              entityLabel="Categoria de Saída"
              basePath="/financial/expense-category-catalog"
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
